<uni-loader *ngIf="isLoaderActive"></uni-loader>